import { SOURCE_KEY_MAP } from '@intelligence/_config/sourceMetric';

export enum RegionType {
  Region = 'region',
  Market = 'market',
}

export enum DateTypeFrontend {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
}

export enum DateTypeBackend {
  Day = 'daily',
  Week = 'weekly',
  Month = 'monthly',
}

// export enum TableSortOrPageChangeCallbackType {
//   SortChange = 'sorttype',
//   PageChange = 'pagetype',
// }

export enum SortType {
  Asc = 'asc',
  Desc = 'desc',
}

export enum SortMode {
  Circle = 1,
  Value = 0,
}

// echart类型枚举
export enum ChartType {
  // 横向柱状图
  BarHorizontal = 'bar-horizontal',
  // 柱状图
  Bar = 'bar',
  // 折线图
  Line = 'line',
  // 饼图
  Pie = 'pie',
  // 饼图
  StackedLine = 'stackedLine',
}

export enum FormMode {
  Add = 1,
  Edit = 2,
}

export const MobileDetailsSegment = [
  { text: 'dbi_active_users', value: 'activeusers' },
  { text: 'dbi_revenue', value: 'revenue' },
  { text: 'dbi_downloads', value: 'downloads' },
  { text: 'dbi_retention', value: 'retention' },
  { text: 'dbi_monthly_retention', value: 'retention_monthly' },
  { text: 'dbi_lifetime_retention', value: 'retention_lifetime' },
  { text: 'dbi_rpd', value: 'rpd' },
];

export const PcConsoleAllDetailsSegment = [
  { text: 'dbi_pcu', value: 'pcu' },
  { text: 'dbi_acu', value: 'acu' },
  { text: 'dbi_digital_revenue', value: 'digitalRevenue' },
  { text: 'dbi_physical_revenue', value: 'physicalRevenue' },
  { text: 'dbi_physical_revenue', value: 'revenue' },
  { text: 'dbi_steam_sales', value: 'steamSales' },
  { text: 'dbi_newzoo_metrics', value: 'newzooMetrics' },
];

export const SUM = 'sum';
export const AVG = 'avg';
export const MAX = 'max';
// 详情页宽表增加Sum、Avg、Max及是否有bydevice（https://doc.weixin.qq.com/sheet/e3_AQQAXQbtADMO6XgsXBFQfyGTCOYea?scode=AJEAIQdfAAolP2IjlSAQQAXQbtADM&tab=BB08J2）

export const segType = {
  activeuser: 'activeuser',
  revenue: 'revenue',
  engagement: 'Engagement',
  churnacq: 'Churn/Acquisition',
  timeSpent: 'Time Spent',
  retention: 'Retention',
};
export const dataSourceType = {
  mscience: 'mscience',
  steamcharts: 'steamcharts',
  vginsights: 'vginsights',
  npd: 'npd',
  newzoo_weight: 'newzoo_weight',
  newzoo: 'newzoo',
  famitsu: 'famitsu',
  gsd: SOURCE_KEY_MAP.GSD,
  gamalytic: 'gamalytic',
  source_steam: 'source_steam',
  alinea: 'alinea',
};

// 根据游戏ID获取游戏详情-通用-RPD
export const CUSTOM_FIELDS_RPD = [
  'cover',
  'entity_name',
  'other_name',
  'publisher',
  'country_abbre',
  'country_name_en',
  'parent_publisher',
  'developer_country_name_en',
  'developer_country_abbre',
  'developer_parent',
  'genre',
  'sub_genre',
  'iegg_genre',
  'iegg_sub_genre',
  'release_time',
  'sensortower_tag',
  'app_magic_tags',
];
